export enum AppName {
  SELLER = 'SELLER',
  FIELD_COLLECT = 'FIELD_COLLECT',
  ZONO_MONEY = 'ZONO_MONEY',
  ZONO_DIGITAL = 'zono-digital',
}

export enum DevicePlatform {
  ANDROID = 'ANDROID',
  IOS = 'IOS',
  WEB = 'WEB',
  APP = 'APP',
}
